import React from 'react';
import PropTypes from 'prop-types';
import { MdTile } from '@miljodirektoratet/md-react';
import { MdPinIcon64 } from '@miljodirektoratet/md-react';

const TilesComponent = ({ description, heading, href, icon, mode, theme }) => (
  <MdTile
    description={description}
    heading={heading}
    href={href}
    icon={icon}
    mode={mode}
    theme={theme}
  />
);

TilesComponent.propTypes = {
  description: PropTypes.string,
  heading: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.element,
  mode: PropTypes.string,
  theme: PropTypes.string,
};

TilesComponent.defaultProps = {
  description: "Oversikt over dine målestasjoner",
  heading: "Målinger",
  href: "#",
  icon: <MdPinIcon64 height={64} width={64} />, 
  mode: "large",
  theme: "primary",
};

export default TilesComponent;